<script>
import {
    layoutComputed
} from "@/state/helpers";
import Vertical from "./vertical-manage";
// import Horizontal from "./horizontal";
/* eslint-disable no-console */
export default {
    components: {
        Vertical,
        // Horizontal,
    },
    data() {
        return {};
    },
    computed: {
        ...layoutComputed,
    },
    methods: {},
    mounted() {
        // document.querySelector("html").setAttribute('dir', 'rtl');

        const user = JSON.parse(localStorage.getItem('user'));    
        // console.log(JSON.stringify(user));

        if(user == null) {
            this.$router.push(this.$route.query.redirectFrom || {
                name: "manage-login"
            });
        } else {
            if(user.manage_type == 1)  {
            this.$router.push(this.$route.query.redirectFrom || {
                    name: "manage-login"
                });
            }
        }


        
    }
};
</script>

<template>
<div>
    <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
        <slot />
    </Vertical>

    <!-- <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
        <slot />
    </Horizontal> -->
</div>
</template>
